import Vue from 'vue'
import Store from '@/filterCards/store'
import App from '@/filterCards/App.vue'
import { Blue } from '!/js/core';
import VueMoment from 'vue-moment';

Vue.config.devtools = true
Vue.config.productionTip = false

const props = {};
const util = new Blue(props);

util.ready('mount_filter_cards', '[filter-cards]', el => {
	const id = el.getAttribute('filter-cards')
	const layout = el.getAttribute('layout')
	let contentTypes = el.getAttribute('content-types')
	let sortOrder = el.getAttribute('sort-order')
	let topics = el.getAttribute('topics')
	let practiceGroups = el.getAttribute('practice-groups')
	let taskForces = el.getAttribute('task-forces')
	let businessCategories = el.getAttribute('business-categories')
	let showContentTypesFilter = el.getAttribute('show-content-types-filter')
	let startDate = el.getAttribute('start-date')
	let endDate = el.getAttribute('end-date')
	let topicFilters = el.getAttribute('topic-filters');

	if(practiceGroups)
	{
		if(practiceGroups !== 'server')
			practiceGroups = practiceGroups.split(',')
	}

	if(taskForces)
		taskForces = taskForces.split(',')

	if(contentTypes)
	{
		let json = atob(contentTypes)
		contentTypes = JSON.parse(json)
	}

	if(topics)
	{
		let json = atob(topics)
		topics = JSON.parse(json)
	}


	if(businessCategories)
	{
		let json = atob(businessCategories)
		businessCategories = JSON.parse(json)
	}

	Vue.use(VueMoment);

	const app = new Vue({
		store: new Store,
		render: h => h(App,
			{
				props: {
					id,
					layout,
					practiceGroups,
					taskForces,
					businessCategories,
					contentTypes,
					topics,
					showContentTypesFilter,
					startDate,
					endDate,
					topicFilters,
					sortOrder
				}
			})
	});
	app.$mount(el)
})

/*-- import aliases -----------
'!/...' -> project root
'~/...' -> vue folder root
'@/...' -> vue/src folder root
-----------------------------*/